export default __webpack_public_path__ + "static/media/cloudez-footer.083e1f9a.svg";